/// <reference types="@types/googlemaps" />
import { Component, OnInit, ViewChild } from '@angular/core';
import locations from "../../assets/geocoder/data/location_output.json";

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit { 
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  locations: any;
  heatmap: google.maps.visualization.HeatmapLayer = null;

  constructor() { }

  ngOnInit() {
    let mapProp = {
      center: new google.maps.LatLng(16.8661, 96.1951),
      zoom: 2,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
 
    /*
    // unused heatmap
    var outerMap = this.map;
    var heatMap = this.heatmap;
    fetch("/assets/location_history.json").then(function(response) {
      response.json().then(function(result) {
        console.log("there");
        let locations = result.locations.map((val) => {
          return new google.maps.LatLng(val.latitudeE7 * (10 ** -7), val.longitudeE7 * (10 ** -7));
        });
        
        heatMap = new google.maps.visualization.HeatmapLayer({
          data: locations,
          map: outerMap,
          radius: 21,
        });
      });
    });
    */
    
    // translates addresses into coordinates
    let outerMap = this.map;
    for (let address of locations) {
      let latlong = new google.maps.LatLng(address.latitude, address.longitude);
      let marker = new google.maps.Marker({
        map: outerMap,
        position: latlong
    });
    }
  }

  /*
  // deprecated because geocoding can be executed locally with a Python script
  geocode(address: string) {
    let geocoder = new google.maps.Geocoder();
    let outerMap = this.map;
    let root = this;
    geocoder.geocode( { 'address': address}, 
    function (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) {
      if (status == google.maps.GeocoderStatus.OK) {
        let marker = new google.maps.Marker({
            map: outerMap,
            position: results[0].geometry.location
        });
      } 
      else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
        setTimeout(function() {
          root.geocode(address);
      }, 50);
      }
      else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });
  }
  */
}
